
<div class="emission" *ngIf="show.emission">
  <app-kontablenew
  title = "{{'voucherCouponsMg.title_Emission' | translate}}"
  id="emission_Table"
  [columns] = "[
  'channel',
  'storeId',
  { field: 'dateTime', title: 'voucherCouponsMg.dt_emission_date', bodyTemplate: dateTimeTemplate },
  'transaction',
  'terminalId',
  'operationId',
  'message'
]"
[titles] = "['voucherCouponsMg.dt_emission_channel','voucherCouponsMg.dt_emission_pv','voucherCouponsMg.dt_emission_trans','voucherCouponsMg.dt_emission_cash','voucherCouponsMg.dt_emission_oper','voucherCouponsMg.dt_emission_message']"
[paginationType]="paginationType"
[showGlobalFilter]="false"
[showReport]="false"
[showInfoButton]="true"
[showAddButton]="false"
[showEditButton]="false"
[showDeleteButton]="false"
[showRecoverButton]="false"
[showDetailsButton]="false"
[fixedFilters]="initialFilters"
[service]="srvVoucherCoupon"
[methodsNames]="methodsNames"
[columnFiltersEnabled]="false"
[showRowButtons]="false"
[showResetFiltersBtn]="false"
#Use>


<ng-template #dateTimeTemplate data-testid="dateTimeTemplate" let-row>
  <span>{{getDateTime(row.dateTime)}}</span>
</ng-template>

<ng-template #printedTemplate data-testid="printedTemplate" let-row>
  <span *ngIf="row.printed === true">{{'common.yes' | translate}}</span>
  <span *ngIf="row.printed === false">{{'common.no' | translate}}</span>
</ng-template>

</app-kontablenew>
</div>



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg-detail/emission/emission.component.html